<template>
  <div class="w-100 h-100 m-0" style="padding: 32px; background: #FFFFFF;">
    <div class="d-flex flex-column" style="gap: 40px;">
      <div class="m-0 p-0 acry-page-title justify-content-center">チケット一覧</div>

      <!-- パンクズ -->
      <div class="d-flex" style="gap: 14px; font-size: 13px;">
        <div class="c-pointer" style="text-decoration: underline;" @click="onClickReturnTop()" >
          ACRY TICKET TOP
        </div>
        <div>
          ＞
        </div>
        <div>
          チケット一覧
        </div>
      </div>

      <TicketCodeLookupForm v-model="ticketSearchCode" @search="executeTicketLookup" />

      <!-- コンテンツ -->
      <div class="d-flex flex-column">
        <div class="m-0 p-0 acrypro-text-main-bold text-start" style="height: 35px; border-bottom: solid 1px #8C9BC6;">
          チケット発行履歴リスト
        </div>

        <div class="d-flex flex-wrap" style="gap: 8px; padding-top: 24px;">
          <div v-for="(event, key) in this.$store.state.acrylicTicketCouponManager.eventList" :key="key" class="event-cell d-flex flex-column">
            <div class="event-name" style="height: 20px; font-size 15px;">
              <div style="margin-top: -2px;">
                {{event.name}}
              </div>
            </div>
            <div class="event-status" :style="getStatusColor(event)">
              <p style="margin-top: 2px;">{{ getStatusText(event) }}</p>
            </div>
            <img v-if="event.preview" class="event-image" :src="event.preview" style="border: 1px solid #D2D2D2;" @click="onClickEdit(event)">
            <div v-if="!event.preview" class="event-image d-flex flex-column justify-content-center" style="background: #EEECF1; font-size: 16px; color: #BDBDBD; border: 1px solid #D2D2D2;">
              <div>
                No
              </div>
              <div>
                image
              </div>
            </div>
            <div v-if="isIssueTicketEvent(event)" class="w-100" style="height: 40px;">
              <button class="w-100 h-100 m-0 acry-btn fw-bold" style="border-radius: 100px; font-size: 16px;" @click="onClickIssueCodeHistory(event)">
                発行コード履歴
              </button>
            </div>
            <div v-if="!isIssueTicketEvent(event)" class="w-100" style="height: 40px;">
              <button class="w-100 h-100 m-0 disable-btn fw-bold" style="border-radius: 100px; font-size: 16px; cursor: auto;">
                発行コード履歴
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <TicketCodeLookupModal
      :value="ticketModalOpen"
      :result="ticketResult"
      :format-date="formatDate"
      @input="ticketModalOpen = $event"
    />
  </div>
</template>

<script>
import { CreateImageElement } from "@/js/CommonFunc.js";
import { CenterViewState, GetCanvasSize, GetAcryProTicketProductId } from "@/js/Const.js";
import { FirebaseCommon } from "@/js/FirebaseCommon.js";
import { FileKit } from "@/js/FileKit.js";
import { OffScreen } from "@/js/OffScreen.js";
import ticketCodeLookupMixin from "@/mixins/ticketCodeLookupMixin.js";
import TicketCodeLookupForm from "@/components/acyrpro/ticket/shared/TicketCodeLookupForm.vue";
import TicketCodeLookupModal from "@/components/acyrpro/ticket/shared/TicketCodeLookupModal.vue";


export default {
  name: "CenterViewEventTicketIssueHistory_Ap",
  components: {
    TicketCodeLookupForm,
    TicketCodeLookupModal,
  },
  mixins: [ticketCodeLookupMixin],
  props: {},
  data: function () {
    return {
      issueData:[],

    };
  },
  computed: {
    getStatusColor() {
      return function (event) {
        if( event.configured ){
          if( this.$store.state.acrylicTicketCouponManager.isIssueTicketEvent(event.docId) ){
            return {
              "color": "#FFFFFF",
              "background": "#595959",
            };
          }else{
            return {
              "color": "#BDBDBD",
              "background": "#F5F7FA",
            };
          }
        }else{
          return {
            "background": "#BC6665",
          };
        }
      };
    },
  },
  async created() {
    this.$store.state.centerViewRef.scrollTop = 0;
    this.$store.commit("hideRightMenu");
    this.$store.commit("showLoading");

    await this.$store.state.acrylicTicketCouponManager.update().catch(() => {
      this.$store.commit("hideLoading");
      this.$store.commit("showMessage", "エラーが発生しました");
    });
    await this.$store.state.acrylicTicketCouponManager.resetEditData();

    this.$store.commit("hideLoading");
  },
  methods: {
    getStatusText(event){
      if( event.configured ){
        if( this.$store.state.acrylicTicketCouponManager.isIssueTicketEvent(event.docId) ){
          return "有効コードあり";
        }else{
          return "有効コードなし";
        }
      }else{
        return "登録再開する";
      }
    },
    isIssueTicketEvent(event){
      return this.$store.state.acrylicTicketCouponManager.isIssueTicketEvent(event.docId);
    },

    onClickReturnTop(){
      this.$store.commit("setCenterViewState", CenterViewState.EventManagement);
    },


    async onClickEdit(event){
      this.$store.commit("resetEventCreateData");
      this.$store.commit("showLoading");

      this.$store.commit("setEventCreateEventSelectSize", event.size);
      this.$store.commit("setEventCreateEventUserEdit", event.isUserEdit);
      this.$store.commit("setEventCreateEventIsShippingFee", event.isShippingFee);

      // 編集を行うために既存のデータを設定していく
      this.$store.commit("setEventCreateEventIsEdit", true);
      this.$store.commit("setEventCreateDocId", event.docId);
      this.$store.commit("setEventCreateEventName", event.name);
      this.$store.commit("setEventCreateEventIssuerName", event.issuerName);
      this.$store.commit("setEventCreateEventFolderName", event.folderName);

      if( event.design ){
        const designFile = await FirebaseCommon.downloadPngImage(event.design);
        this.$store.commit("setEventCreateDesignData", new FileKit(designFile));
      }

      if( event.cutline ){
        const cutlineFile = await FirebaseCommon.downloadSvgImage(event.cutline);
        const cutlineFileKit = new FileKit(cutlineFile)
        this.$store.commit("setEventCreateCutlineData", cutlineFileKit);

        const ProductId = GetAcryProTicketProductId(event.isShippingFee, event.size, false);
        let canvasSize = GetCanvasSize(ProductId);
        const imageWidth = canvasSize.width;
        const imageHeight = canvasSize.height;
        let offScreen = new OffScreen(imageWidth, imageHeight);

        let image = await CreateImageElement(cutlineFileKit.fileURL);
        offScreen.drawImage(image, 0, 0, imageWidth, imageHeight);
        offScreen.replacement("#000000")

        const blob = await new Promise((resolve) => {
          offScreen.toBlob(function (blob) {
            resolve(blob);
          });
        });

        this.$store.commit("setEventCreateCutlineImageURL", URL.createObjectURL(blob));
      }

      if( event.nonEditable ){
        const nonEditableFile = await FirebaseCommon.downloadPngImage(event.nonEditable);
        this.$store.commit("setEventCreateNonEditableData", new FileKit(nonEditableFile));
      }

      if( event.banner1 ){
        const bannerFile = await FirebaseCommon.downloadPngImage(event.banner1);
        this.$store.commit("setEventCreateBannerData1", new FileKit(bannerFile));
      }

      if( event.banner2 ){
        const bannerFile = await FirebaseCommon.downloadPngImage(event.banner2);
        this.$store.commit("setEventCreateBannerData2", new FileKit(bannerFile));
      }

      if( event.preview ){
        const previewFile = await FirebaseCommon.downloadPngImage(event.preview);
        this.$store.commit("setEventCreatePreviewData", new FileKit(previewFile));
      }

      this.$store.state.acrylicTicketCouponManager.selectEditSetting = event;

      // 一旦完成しているかどうかで遷移先を変更
      if( event.configured ){
        this.$store.commit("setCenterViewState", CenterViewState.EventEdit);
      }else{
        this.$store.commit("setCenterViewState", CenterViewState.EventCreate);
      }
    },

    async onClickIssueCodeHistory(event){
      this.$store.commit("resetEventCreateData");
      this.$store.commit("showLoading");

      this.$store.commit("setEventCreateEventSelectSize", event.size);
      this.$store.commit("setEventCreateEventUserEdit", event.isUserEdit);
      this.$store.commit("setEventCreateEventIsShippingFee", event.isShippingFee);

      // 編集を行うために既存のデータを設定していく
      this.$store.commit("setEventCreateEventIsEdit", true);
      this.$store.commit("setEventCreateDocId", event.docId);
      this.$store.commit("setEventCreateEventName", event.name);
      this.$store.commit("setEventCreateEventIssuerName", event.issuerName);
      this.$store.commit("setEventCreateEventFolderName", event.folderName);

      if( event.design ){
        const designFile = await FirebaseCommon.downloadPngImage(event.design);
        this.$store.commit("setEventCreateDesignData", new FileKit(designFile));
      }

      if( event.cutline ){
        const cutlineFile = await FirebaseCommon.downloadSvgImage(event.cutline);
        const cutlineFileKit = new FileKit(cutlineFile)
        this.$store.commit("setEventCreateCutlineData", cutlineFileKit);

        const ProductId = GetAcryProTicketProductId(event.isShippingFee, event.size, false);
        let canvasSize = GetCanvasSize(ProductId);
        const imageWidth = canvasSize.width;
        const imageHeight = canvasSize.height;
        let offScreen = new OffScreen(imageWidth, imageHeight);

        let image = await CreateImageElement(cutlineFileKit.fileURL);
        offScreen.drawImage(image, 0, 0, imageWidth, imageHeight);
        offScreen.replacement("#000000")

        const blob = await new Promise((resolve) => {
          offScreen.toBlob(function (blob) {
            resolve(blob);
          });
        });

        this.$store.commit("setEventCreateCutlineImageURL", URL.createObjectURL(blob));
      }

      if( event.nonEditable ){
        const nonEditableFile = await FirebaseCommon.downloadPngImage(event.nonEditable);
        this.$store.commit("setEventCreateNonEditableData", new FileKit(nonEditableFile));
      }

      if( event.banner1 ){
        const bannerFile = await FirebaseCommon.downloadPngImage(event.banner1);
        this.$store.commit("setEventCreateBannerData1", new FileKit(bannerFile));
      }

      if( event.banner2 ){
        const bannerFile = await FirebaseCommon.downloadPngImage(event.banner2);
        this.$store.commit("setEventCreateBannerData2", new FileKit(bannerFile));
      }

      if( event.preview ){
        const previewFile = await FirebaseCommon.downloadPngImage(event.preview);
        this.$store.commit("setEventCreatePreviewData", new FileKit(previewFile));
      }

      this.$store.state.acrylicTicketCouponManager.selectEditSetting = event;

      this.$store.commit("setCenterViewState", CenterViewState.TicketIssueHistory);
    },

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.event-cell{
  height: 486px;
  width: 240px;
  padding: 16px;
  gap: 8px;
  border: solid 1px #D1D5DB;
}
.event-name{
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.event-status{
  font-size: 16px;
  font-weight: 700;
  height: 30px;
  width: 100%;
}
.event-image{
  height: 340px;
  width: 100%;
  object-fit: contain;
  cursor: pointer;
}

.disable-btn {
  margin: 10px;
  padding: 3px 30px;
  color: #BDBDBD;
  background-color: #F5F7FA;
  border-radius: 15px;
  font-size: 15px;
  border: 0px;
}
</style>


